export default __webpack_public_path__ + "static/media/colombia.09f605d9.svg";